import { render, staticRenderFns } from "./MySources.vue?vue&type=template&id=838a88a4&scoped=true&"
import script from "./MySources.vue?vue&type=script&lang=js&"
export * from "./MySources.vue?vue&type=script&lang=js&"
import style0 from "./MySources.vue?vue&type=style&index=0&id=838a88a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838a88a4",
  null
  
)

export default component.exports